var TimeValidation = /** @class */ (function () {
    function TimeValidation() {
    }
    TimeValidation.validate = function (registrationFormGroup) {
        if (registrationFormGroup.controls) {
            if (registrationFormGroup.controls.closedTime) {
                if (registrationFormGroup.controls.closedTime.value) {
                    if (registrationFormGroup.controls.closedTime.value.length < 4) {
                        registrationFormGroup.controls.closedTime.setErrors({
                            invalid: true
                        });
                    }
                    else {
                        registrationFormGroup.controls.closedTime.setErrors(null);
                    }
                }
            }
            if (registrationFormGroup.controls.scheduledTime) {
                if (registrationFormGroup.controls.scheduledTime.value && registrationFormGroup.controls.scheduledTime.value.length < 4) {
                    registrationFormGroup.controls.scheduledTime.setErrors({
                        invalid: true
                    });
                }
            }
        }
    };
    return TimeValidation;
}());
export { TimeValidation };
